import { translate } from '@comparacar/lib/src/translations'

export default function useLeadButton({ id, provider, idPrefix }: { id: string; provider?: string; idPrefix: string }) {
  const link = `/assinar/lead/${id}${provider ? `?origin=${provider}` : ''}`
  const idLabel = `${idPrefix}`
  const buttonLabel = translate('useLeadButton.label')

  return { buttonLabel, link, idLabel }
}
